import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PdfStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M2.75 20V4C2.75 2.48122 3.98122 1.25 5.5 1.25H12.5C12.6989 1.25 12.8896 1.32907 13.0303 1.46973L20.0303 8.46973C20.1709 8.61038 20.25 8.80109 20.25 9V11C20.25 11.4142 19.9142 11.75 19.5 11.75C19.0858 11.75 18.75 11.4142 18.75 11V9.75H14.498C12.9794 9.75 11.748 8.5188 11.748 7V2.75H5.5C4.80964 2.75 4.25 3.30964 4.25 4V20C4.25 20.6904 4.80964 21.25 5.5 21.25H19.5C19.9142 21.25 20.25 21.5858 20.25 22C20.25 22.4142 19.9142 22.75 19.5 22.75H5.5C3.98122 22.75 2.75 21.5188 2.75 20ZM13.248 7C13.248 7.69034 13.8077 8.25 14.498 8.25H17.6895L13.248 3.80859V7Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.9875 15.0125C11.3395 15.0125 11.625 15.2979 11.625 15.65C11.625 16.0021 11.3395 16.2875 10.9875 16.2875H10.35V15.0125H10.9875ZM9.07495 14.375C9.07495 14.2117 9.13633 14.0628 9.23728 13.95C9.35401 13.8196 9.52365 13.7375 9.71245 13.7375H10.9875C11.4429 13.7375 11.8612 13.8967 12.1896 14.1625C12.6229 14.5131 12.9 15.0492 12.9 15.65C12.9 15.8735 12.8616 16.0881 12.7911 16.2875C12.5286 17.0303 11.8202 17.5625 10.9875 17.5625H10.35V18.625C10.35 18.9771 10.0645 19.2625 9.71245 19.2625C9.36037 19.2625 9.07495 18.9771 9.07495 18.625V14.375Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.3875 13.7375C14.0354 13.7375 13.75 14.0229 13.75 14.375V18.625C13.75 18.9771 14.0354 19.2625 14.3875 19.2625H15.4803C16.6201 19.2625 17.575 18.3596 17.575 17.2083V15.7917C17.575 14.6404 16.6201 13.7375 15.4803 13.7375H14.3875ZM16.2098 17.5625C16.0767 17.81 15.8075 17.9875 15.4803 17.9875H15.025V15.0125H15.4803C15.95 15.0125 16.3 15.3782 16.3 15.7917V17.2083C16.3 17.3337 16.2678 17.4547 16.2098 17.5625Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.0625 19.2625C19.137 19.2625 19.2085 19.2497 19.275 19.2262C19.5226 19.1387 19.7 18.9025 19.7 18.625V17.1375H21.1875C21.5395 17.1375 21.825 16.8521 21.825 16.5C21.825 16.1479 21.5395 15.8625 21.1875 15.8625H19.7V15.0125H21.6125C21.9645 15.0125 22.25 14.7271 22.25 14.375C22.25 14.0229 21.9645 13.7375 21.6125 13.7375H19.0625C18.7104 13.7375 18.425 14.0229 18.425 14.375V18.625C18.425 18.9771 18.7104 19.2625 19.0625 19.2625Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PdfStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PdfStrokeIcon;
